const setMedicalHistory = (state, medicalHistory) =>
  (state.medicalHistory = medicalHistory);

const setMedicalHistories = (state, medicalHistories) =>
  (state.medicalHistories = medicalHistories);

let mutations = {
  setMedicalHistory,
  setMedicalHistories
};

export default mutations;
